/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { ProductCardProps } from '@coursera/cds-core';
import { Grid, ProductCard, VisuallyHidden } from '@coursera/cds-core';

import { useStatusTagRedesignExperimentVariant } from 'bundles/product-card/components/utils/getStatusTagRedesignExperimentVariant';

import _t from 'i18n!nls/search-common';

const styles = {
  productCard: css`
    padding: 0 var(--cds-spacing-100) var(--cds-spacing-300);
  `,
};

type CdsCardsProps = {
  resultsPerPage: number;
  variant?: ProductCardProps['variant'];
  coachOpen?: boolean;
  enableStickyFilterBar?: boolean;
};

export const ProductCardV2Placeholder = ({
  variant = 'grid',
  experimentVariant,
}: {
  variant?: ProductCardProps['variant'];
  experimentVariant?: ProductCardProps['experimentVariant'];
}) => {
  const placeholderProps: ProductCardProps = {
    variant,
    productType: ' ',
    experimentVariant,
  };

  return <ProductCard {...placeholderProps} loading={true} />;
};

export const ProductsCardsCdsPlaceholder = ({
  resultsPerPage,
  variant,
  coachOpen = false,
  enableStickyFilterBar = false,
}: CdsCardsProps) => {
  const searchCards = Array.from({ length: resultsPerPage }, (v, i) => i);

  const desktopCardSize = React.useMemo(() => {
    let lgCardSize: 3 | 4 | 12 = 4;

    if (enableStickyFilterBar) {
      lgCardSize = 3;
    }

    if (coachOpen) {
      lgCardSize = 4;
    }

    if (variant === 'list') {
      lgCardSize = 12;
    }

    return lgCardSize;
  }, [enableStickyFilterBar, coachOpen, variant]);

  const { productCardExperimentVariant: experimentVariant } = useStatusTagRedesignExperimentVariant();

  return (
    <Grid container>
      <VisuallyHidden role="status">{_t('Loading search results')}</VisuallyHidden>

      {searchCards.map((placeholderIndex) => (
        <Grid
          key={placeholderIndex}
          item
          lg={desktopCardSize}
          md={variant === 'list' ? 12 : 4}
          sm={variant === 'list' ? 12 : 6}
          xs={12}
          css={styles.productCard}
        >
          <ProductCardV2Placeholder variant={variant} experimentVariant={experimentVariant} />
        </Grid>
      ))}
    </Grid>
  );
};
